export default __webpack_public_path__ + "static/media/ak74u.72bc1de5.svg";